const MODULE_CONFIG = {
  "Full Stack Web Development": [
    { name: "HTML & CSS Fundamentals",      duration: "40 Hours" },
    { name: "JavaScript Essentials",        duration: "60 Hours" },
    { name: "React.js Development",         duration: "80 Hours" },
    { name: "Node.js & Express.js",         duration: "70 Hours" },
    { name: "MongoDB & Database Design",    duration: "50 Hours" },
    { name: "REST API Development",         duration: "45 Hours" },
    { name: "Deployment & DevOps Basics",   duration: "30 Hours" },
  ],
  "Data Science & Machine Learning": [
    { name: "Python for Data Science",      duration: "50 Hours" },
    { name: "Data Analysis with Pandas",    duration: "40 Hours" },
    { name: "Data Visualization",           duration: "30 Hours" },
    { name: "Machine Learning Fundamentals",duration: "80 Hours" },
    { name: "Deep Learning with TensorFlow",duration: "70 Hours" },
    { name: "Natural Language Processing",  duration: "60 Hours" },
    { name: "Model Deployment",             duration: "35 Hours" },
  ],
  "Digital Marketing": [
    { name: "SEO & Content Strategy",       duration: "30 Hours" },
    { name: "Social Media Marketing",       duration: "25 Hours" },
    { name: "Google Ads & PPC",             duration: "35 Hours" },
    { name: "Email Marketing",              duration: "20 Hours" },
    { name: "Analytics & Reporting",        duration: "25 Hours" },
  ],
  "UI/UX Design": [
    { name: "Design Thinking",              duration: "20 Hours" },
    { name: "Figma Essentials",             duration: "40 Hours" },
    { name: "User Research Methods",        duration: "25 Hours" },
    { name: "Prototyping & Wireframing",    duration: "35 Hours" },
    { name: "Usability Testing",            duration: "20 Hours" },
  ],
  "Python Programming": [
    { name: "Python Basics",                duration: "30 Hours" },
    { name: "Object-Oriented Programming",  duration: "40 Hours" },
    { name: "File Handling & APIs",         duration: "25 Hours" },
    { name: "Django Web Framework",         duration: "60 Hours" },
    { name: "Flask Microframework",         duration: "40 Hours" },
  ],
  "Cyber Security": [
    { name: "Network Security Fundamentals",duration: "45 Hours" },
    { name: "Ethical Hacking Basics",       duration: "60 Hours" },
    { name: "Penetration Testing",          duration: "70 Hours" },
    { name: "Cryptography Essentials",      duration: "35 Hours" },
    { name: "Security Auditing",            duration: "30 Hours" },
  ],
};

const COURSES = Object.keys(MODULE_CONFIG);

module.exports = { MODULE_CONFIG, COURSES };